export interface TransactionData {
  yearmonth: string;
  txncount: number;
  environment: string;
  txnType: string;
}

// Generate dummy data for 4 years (2022-2025)
// export const generateDummyData = (): TransactionData[] => {
//   const data: TransactionData[] = [];
//   const txnTypes = ['e-KYC', 'OTP', 'BFD', 'AUTH'];
//   const environments = ['Production', 'Preproduction'];
//   const years = [2022, 2023, 2024, 2025];
//   const months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

//   years.forEach((year) => {
//     months.forEach((month) => {
//       txnTypes.forEach((txnType) => {
//         environments.forEach((environment) => {
//           // Generate random transaction count
//           // Production has higher volume than Preproduction
//           const baseCount = environment === 'Production' ? 50 : 20;
//           const randomVariation = Math.floor(Math.random() * 100);
//           const txncount = baseCount + randomVariation;

//           data.push({
//             yearmonth: `${year}-${month}`,
//             txncount,
//             environment,
//             txnType,
//           });
//         });
//       });
//     });
//   });

//   return data;
// };

// export const transactionData: TransactionData[] = generateDummyData();

// Helper function to get unique years from data
export const getUniqueYears = (data: TransactionData[]): string[] => {
  const years = Array.from(new Set(data.map((item) => item.yearmonth.split('-')[0])));
  console.log("years ", years);
  return years.sort();
};

// Helper function to get unique months from data
export const getUniqueMonths = (data: TransactionData[]): string[] => {
  const months = Array.from(new Set(data.map((item) => item.yearmonth)));
  return months.sort();
};

// Helper function to get date range
export const getDateRange = (data: TransactionData[]): { start: string; end: string } => {
  const dates = data.map((item) => item.yearmonth).sort();
  return {
    start: dates[0],
    end: dates[dates.length - 1],
  };
};